module.exports = __webpack_public_path__ + "img/loginlogo.aa7cf6f9.png";